module.exports = __webpack_public_path__ + "media/images/samples/home/news/n1@2x-ad3a54346539f7af722fc57f7aa7b850.png";